import { createContext } from 'react'

/** False during the list's first render, true after: rows mounting later settle in. */
export const ListReady = createContext(false)
